import { Banner } from '@sunwebgroup/uds-ui/banner'
import { CheckboxField } from '@sunwebgroup/uds-ui/fields/checkbox-field'
import { FormField } from '@sunwebgroup/uds-ui/fields/form-field'
import * as React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import { useService } from '@/scopes/checkout/domain/hooks'
import { CheckoutCarRentalServiceOption, ServiceType } from '@/scopes/checkout/domain/types'
import styles from './Driver.module.css'

interface CreditCardDriverFormValues {
  [key: string]: boolean
}

export function CreditCardDriverForm({ ...option }: CheckoutCarRentalServiceOption) {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const { driverId, isIncluded } = option
  const intl = useIntl()

  const { participants } = service || {}

  const driver = driverId ? participants?.[driverId] : null

  const { control, formState: { errors }, setValue } = useFormContext<CreditCardDriverFormValues>()
  const fieldName = `hasCreditCardDriver${driverId}`

  React.useEffect(() => {
    if (driver && driverId) {
      setValue(fieldName, Boolean(driver.birthdate && driverId))
    }
  }, [fieldName, driver, driverId, setValue])

  if (!service || !option || !isIncluded)
    return null

  return (
    <form data-qa="car-rental-edit-form-container">
      <FormField status={errors[fieldName] ? 'error' : undefined}>
        <div className={styles.formFieldContent}>
          <Controller
            name={fieldName}
            control={control}
            rules={{
              required: intl.formatMessage({
                id: 'checkout_steps_ancillaries_car_rental_filtering_form_driver_credit_card_required_message',
              }),
            }}
            defaultValue={Boolean(driver?.birthdate && driverId)}
            render={({ field }) => (
              <CheckboxField
                label={intl.formatMessage({
                  id: 'checkout_steps_ancillaries_car_rental_filtering_form_driver_credit_card_label',
                })}
                variant="outlined"
                checked={field.value}
                onCheckedChange={field.onChange}
                id={field.name}
                required
                data-qa="car-rental-edit-form-container-credit-card-checkbox"
              />
            )}
          />
          {errors[fieldName] && (
            <Banner color="danger" hasIcon text={errors[fieldName]?.message ?? ''} size="M" contentIsCentered />
          )}
        </div>
      </FormField>
    </form>
  )
}
